import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";

function ProductPage() {
  const [product, setProduct] = useState({ size: [] });
  const [selectedSize, setSelectedSize] = useState(null);

  const handleSizeChange = (selectedOption) => {
    setSelectedSize(selectedOption);
    // console.log("Selected Size ID:", selectedOption.value);
  };

  const sizeOptions = product.size.map((size) => ({
    value: size.id,
    label: `${size.size} - ₹${size.amount}`,
  }));

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#911077",
      borderColor: state.isFocused ? "#a31a89" : "#911077",
      color: "#fff",
      borderRadius: 10,
      padding: "2px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#a31a89",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "#fff",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 10,
      overflow: "hidden",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? "#a31a89"
        : state.isSelected
        ? "#911077"
        : "#fff",
      color: state.isFocused || state.isSelected ? "#fff" : "#000",
      "&:active": {
        backgroundColor: "#911077",
      },
    }),
  };

  return (
    <div className="container">
      <h4>Select Size:</h4>
      <Select
        options={sizeOptions}
        styles={customStyles}
        onChange={handleSizeChange}
        value={selectedSize}
        placeholder="Choose size"
        className="w-100"
      />

      <div className="mt-4">
        {selectedSize && (
          <p>
            You selected: <strong>{selectedSize.label}</strong>
          </p>
        )}
      </div>
    </div>
  );
}

export default ProductPage;
